import React ,{useCallback, useState} from   "react";
import { View, StyleSheet, Text, FlatList } from "react-native";
import { useFocusEffect } from '@react-navigation/native'
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import dateNow from '../utility/dateNow';
import { ListImageItem } from "../components/lists";
import arrayFilter from "../utility/arrayFilter";

    var arrayPublications = []
    var pageNumber = 0
    var blockSize = 5
    var pointer = 0  
    var uriPublications =  connectionConfig.imageUrl + '/imagesPublications/'

function HistoryDetailScreen({ route }) {
   // console.log('route.params->',  route.params)

   useFocusEffect(
   useCallback(() => {
    console.log('FeedScreen',route.params.screen )
    pointer = 0
    arrayPublications = []
    pageNumber = 0
    blockSize = 5
    date = dateNow()
    if(route.params.screen  === 'FeedScreen'){
      console.log('entre a escreeen ->', route.params.screen, 'userId ->', route.params.userId, 'route params ->', route.params )
      getHistorysFeed()
    }else{
      console.log('route.params.arrayUserHistory ->', route.params.arrayUserHistoryHook)
      //arrayPublications = route.params.arrayUserHistory
      //setItems(route.params.arrayUserHistoryHook)
      setItems(route.params.arrayUserHistory)

    }   
      }, [])
   )
   var date
   const [ items, setItems ] =  useState([]) // para que es
//---------------------------------------------
//prueba 
//---------------------------------------------
const getHistorysFeed = async () => {
  //debugger
  pointer = pageNumber * blockSize
 // setLoading(true)
  var post_values = {
    userId: route.params.userId,
    pointer: pointer,
    blockSize: blockSize
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl + '/SelectHistorys/', configurationPost)
    .then(response => response.json())
    .then(response => {
      if (response.data.length === 0) {
        if (pageNumber > 0) {
         // setLoading(false)
        } else {
          //setPublicationSucces(false)
          ///setLoading(false)
        }
      } else {
        pageNumber++
        if (arrayPublications.length > 0) {
          arrayPublications = [...arrayPublications, ...response.data]
        } else {
          arrayPublications = response.data
        }      
        //setItems(arrayUserHistory)
        //setLoading(false)
      }
    })
    .catch(err => {
      console.log('getPublications failed :( review internet service)', err)
    })
//-------------------------------------------------------------------------------------
//await inicia una promesa para filtrar arreglo por tiempo de vida de las historias 
await arrayFilter.filterDateHistoryArray( arrayPublications ) 
//cada then es una respuesta de la promesa
//puede haber uno o varios then  
      .then((respuesta) => {
        debugger
            setItems(respuesta)   
      })
      .catch(err => {
        console.log(' failed :( review internet service filterDateHistoryArray ', err)
    })
//-------------------------------------------------------------------------------------
}
  return (

      <View style={styles.card}>
        {
        //.................................................................
        //Sección que valida si no hay historias de las personas que sigues
        //.................................................................
         items.length > 0 ? 
         <FlatList
         data={items}
         keyExtractor={(item) => item.userPublicationId.toString()}
         onEndReachedThreshold={.5}
         onEndReached={() =>{
           if(route.params.screen === 'FeedScreen'){
              getHistorysFeed()
           }
         } }
         horizontal={true}
         renderItem={({ item, index }) => (
           <ListImageItem
           a={console.log('uriPublications + item.userPublicationPhoto', uriPublications + item.userPublicationPhoto)}
           imageUrl={ uriPublications + item.userPublicationPhoto}
          />
         )}
       />
         :
         <View style={styles.mensageContainer}>
           <Text>No cuentas con historias de las personas que sigues por el momento</Text>
         </View>
        }
       
      </View>

  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 15,
    flex : 1,
    overflow: "hidden",
  },
  mensageContainer: {
    flex : 1,
    marginTop: '20%', 
    textAlign:'center'
  },
});

export default HistoryDetailScreen;